
export const FEED_EXPLORE_TAB = 'feed';

export const RECOMMENDED_TIMELINE_TYPE = 1;
export const YOUR_TEAMS_TIMELINE_TYPE = 2;
export const FEATURED_TIMELINE_TYPE = 3;
export const SPORT_TIMELINE_TYPE = 4;
export const TRENDING_TIMELINE_TYPE = 5;
export const FRIENDS_WATCHED_TIMELINE_TYPE = 6;
export const FEED_TIMELINE_TYPE = 7;
